export default __webpack_public_path__ + "static/media/cama-hospital.4186bb68.png";